import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'

const SCRATCH_CAMPAIGN_STATUS_LABELS: Record<string, string> = {
  draft: 'Rascunho',
  active: 'Ativa',
  finished: 'Finalizada',
  cancelled: 'Cancelada',
}

/** Campanhas elegíveis no seletor da página Ganhadores (sem exemplo global nem ocultas). */
export function isScratchCampaignVisibleInWinnersLookup(
  campaign: Pick<RaspadinhaCampaign, 'hidden_from_main' | 'is_global_example'>
): boolean {
  if (campaign.hidden_from_main) return false
  if (campaign.is_global_example === true) return false
  return true
}

export function scratchCampaignToSelectOption(campaign: RaspadinhaCampaign): {
  value: string
  label: string
  subtitle: string | undefined
} {
  const label = campaign.title?.trim() || campaign.name?.trim() || 'Campanha raspadinha'
  const status = campaign.status?.trim()
  const subtitle =
    status && SCRATCH_CAMPAIGN_STATUS_LABELS[status]
      ? SCRATCH_CAMPAIGN_STATUS_LABELS[status]
      : undefined

  return {
    value: String(campaign.id),
    label,
    subtitle,
  }
}
